const setSelectedDashboard = (state, dashboard) => {
  state.commit('setSelectedDashboard', dashboard || {});
};

const setSelectedSupervisorDashboard = (state, dashboard) => {
  state.commit('setSelectedSupervisorDashboard', dashboard);
};

export default {
  setSelectedDashboard,
  setSelectedSupervisorDashboard
};
